import React from 'react';

const SignIn = () => {
  return null;
};

export default SignIn;